module.exports = __webpack_public_path__ + "./images/red_marker.e5da4d.svg";